import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "samplecomponent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Button", -1)
const _hoisted_3 = { class: "samplecomponent__article" }
const _hoisted_4 = { class: "samplecomponent__reactive" }
const _hoisted_5 = { class: "samplecomponent__component" }
const _hoisted_6 = { class: "samplecomponent__resizable" }
const _hoisted_7 = { class: "samplecomponent__options" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text--xs" }, "Props", -1)
const _hoisted_9 = { class: "samplecomponent__article" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", null, "Examples", -1)
const _hoisted_11 = { class: "gap" }
const _hoisted_12 = { class: "gap" }
const _hoisted_13 = { class: "gap" }
const _hoisted_14 = { class: "gap" }
const _hoisted_15 = { class: "gap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputSelect = _resolveComponent("InputSelect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              text: _ctx.props.text,
              title: _ctx.props.title,
              icon: _ctx.props.icon,
              href: _ctx.props.hrefEnabled ? _ctx.props.href : undefined,
              to: _ctx.props.toEnabled ? _ctx.props.to : undefined,
              block: _ctx.props.block,
              disabled: _ctx.props.disabled,
              reverseOrder: _ctx.props.reverseOrder,
              size: _ctx.props.size,
              theme: _ctx.props.theme,
              onClicked: _ctx.clicked
            }, null, 8, ["text", "title", "icon", "href", "to", "block", "disabled", "reverseOrder", "size", "theme", "onClicked"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.theme,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.props.theme = $event)),
              options: _ctx.themesButton,
              label: "theme"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.text,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.props.text = $event)),
              label: "text"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.title,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.props.title = $event)),
              label: "title"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.hrefEnabled,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.props.hrefEnabled = $event)),
              label: "href"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.href,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.props.href = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.toEnabled,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.props.toEnabled = $event)),
              label: "router-link(:to)"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.icon,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.props.icon = $event)),
              options: _ctx.icons,
              label: "icons",
              placeholder: "undefined"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.block,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.props.block = $event)),
              label: "block"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.disabled,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.props.disabled = $event)),
              label: "disabled"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.reverseOrder,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.props.reverseOrder = $event)),
              label: "reverseOrder"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.size,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.props.size = $event)),
              options: _ctx.sizes,
              label: "size"
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_Button, { text: "default" }),
        _createVNode(_component_Button, {
          text: "primary",
          theme: "primary"
        }),
        _createVNode(_component_Button, {
          text: "secondary",
          theme: "secondary"
        }),
        _createVNode(_component_Button, {
          text: "transparent",
          theme: "transparent"
        })
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_Button, {
          text: "disabled",
          disabled: true
        }),
        _createVNode(_component_Button, {
          text: "disabled",
          theme: "primary",
          disabled: true
        }),
        _createVNode(_component_Button, {
          text: "disabled",
          theme: "secondary",
          disabled: true
        }),
        _createVNode(_component_Button, {
          text: "disabled",
          theme: "transparent",
          disabled: true
        })
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_Button, {
          text: "icon",
          icon: "home"
        }),
        _createVNode(_component_Button, {
          text: "disabled",
          icon: "home",
          disabled: true
        }),
        _createVNode(_component_Button, {
          text: "reverseOrder",
          icon: "home",
          reverseOrder: true
        })
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_Button, {
          text: "large lg",
          size: "lg"
        }),
        _createVNode(_component_Button, { text: "default md" }),
        _createVNode(_component_Button, {
          text: "small sm",
          size: "sm"
        })
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_Button, {
          text: "btn text icon",
          icon: "home",
          theme: "text"
        }),
        _createVNode(_component_Button, {
          text: "sm btn text icon",
          icon: "home",
          theme: "text",
          size: "sm"
        }),
        _createVNode(_component_Button, {
          text: "sm btn text icon dis",
          icon: "home",
          theme: "text",
          size: "sm",
          disabled: true
        }),
        _createVNode(_component_Button, {
          text: "btn text",
          theme: "text"
        }),
        _createVNode(_component_Button, {
          text: "btn text dis",
          theme: "text",
          disabled: true
        })
      ])
    ])
  ]))
}